export const SET_ASSETS_PANELS = 'SET_ASSETS_PANELS';
export const SET_ASSETS_PAGES = 'SET_ASSETS_PAGES';
export const SET_ASSETS_COVERS = 'SET_ASSETS_COVERS';
export const SET_LOADING_PANELS = 'SET_LOADING_PANELS';
export const SET_LOADING_PAGES = 'SET_LOADING_PAGES';
export const SET_LOADING_COVERS = 'SET_LOADING_COVERS';
